(() => {
  class FacetsForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.sectionId = this.dataset.section;
      this.timer = null;
      this.form.addEventListener('input', (e) => {
        if (e.target.type === 'range') this.updateOutput(e.target);
      });
      this.form.addEventListener('change', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.submit(), 450);
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        clearTimeout(this.timer);
        this.submit().then(() => this.closest('dialog')?.close());
      });
      this.onExternalChange = (e) => {
        if (e.target.getAttribute('form') === this.form.id && !this.form.contains(e.target)) this.submit();
      };
      document.addEventListener('change', this.onExternalChange);
      this.onClick = (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (!link || !document.getElementById(`ProductGrid-${this.sectionId}`)) return;
        e.preventDefault();
        this.load(link.href);
      };
      document.addEventListener('click', this.onClick);
      this.onPop = () => this.load(window.location.href, false);
      window.addEventListener('popstate', this.onPop);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick);
      document.removeEventListener('change', this.onExternalChange);
      window.removeEventListener('popstate', this.onPop);
    }

    updateOutput(input) {
      const out = input.parentElement.querySelector('output');
      if (out) out.textContent = `${input.dataset.currency || ''}${input.value}`;
    }

    params() {
      const data = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [key, value] of data.entries()) {
        const field = this.form.elements[key];
        if (field && field.type === 'range' && field.value === field.dataset.rangeMax) continue;
        if (value !== '') params.append(key, value);
      }
      return params;
    }

    submit() {
      const url = new URL(this.form.action, window.location.origin);
      url.search = this.params().toString();
      return this.load(url.toString());
    }

    async load(href, push = true) {
      const url = new URL(href, window.location.origin);
      const grid = document.getElementById(`ProductGrid-${this.sectionId}`);
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      if (grid) grid.setAttribute('aria-busy', 'true');
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      try {
        const res = await fetch(fetchUrl.toString(), { signal: this.controller.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        document.querySelectorAll('[data-facets-region]').forEach((region) => {
          const fresh = doc.getElementById(region.id);
          if (!fresh) return;
          if (region.id.startsWith('FacetList-')) {
            region.querySelectorAll('details').forEach((d, i) => {
              const freshDetails = fresh.querySelectorAll('details')[i];
              if (freshDetails) freshDetails.open = d.open;
            });
          }
          region.replaceWith(fresh);
        });
        const status = document.getElementById(`FacetStatus-${this.sectionId}`);
        const count = doc.getElementById(`FacetStatus-${this.sectionId}`);
        if (status && count) status.textContent = count.textContent;
        if (push) window.history.pushState({}, '', url.toString());
        if (window.theme && window.theme.initReveal) window.theme.initReveal();
      } catch (e) {
        if (e.name !== 'AbortError') window.location.href = url.toString();
      } finally {
        const freshGrid = document.getElementById(`ProductGrid-${this.sectionId}`);
        if (freshGrid) freshGrid.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('facets-form')) customElements.define('facets-form', FacetsForm);
})();
